import moment from 'moment';

window.scheduleCalendar = (params) => {
    moment.locale('ru');
    let type = params.type
    let notification = params.notification
    let responsible = params.responsible
    let admins = params.admins
    let adminColor = params.adminColor
    let adminCalendar = params.adminCalendar
    let adminTempCalendar = {}
    let dateSeries = []
    let currentDate = moment().startOf('week')

    const init = () => {
        type = $('[name="type"]:checked').val()
        notification = $('[name="notification"]').is(':checked')
        responsible = $('[name="responsible"]').val()

        event()
        handlerType()
        renderCalendar()
    }


    const event = () => {
        $('.calendar-container').on('click' , 'td', handlerCheck)
        $('#clear-calendar').on('click', () => {
            for (let adminCalendarKey in adminCalendar) {
                adminCalendar[adminCalendarKey] = []
            }
            renderCalendar()
        })
        $('#save-calendar').on('click', handlerSave)
        $('#notification').on('change', () => {
            notification = $('[name="notification"]').is(':checked')
        })
        $('#responsible').on('change', () => {
            responsible = $('[name="responsible"]').val()
        })
        $('#type1, #type2').on('change', () => {
            type = $('[name="type"]:checked').val()
            handlerType()
        })

        handlerTooltip()

        $('#prevMonth').on('click', function () {
            currentDate.subtract(4, 'M')
            renderCalendar()
        })
        $('#prevWeek').on('click', function () {
            currentDate.subtract(1, 'w')
            renderCalendar()
        })
        $('#nextWeek').on('click', function () {
            currentDate.add(1, 'w')
            renderCalendar()
        })
        $('#nextMonth').on('click', function () {
            currentDate.add(4, 'M')
            renderCalendar()
        })
    }

    const handlerType = () => {
        console.log(type)
        if (type === 'double') {
            //проверить что отмечены 2 аминистратора по 2 смены подряд
            dateSeries = []
            for (let adminCalendarKey in adminCalendar) {
                adminCalendar[adminCalendarKey].map(function(item) {
                    dateSeries.push({
                        date: item.date,
                        number: item.number,
                        admin: adminCalendarKey
                    })
                })
            }

            dateSeries.sort((a, b) => {
                return moment(a.date).diff(moment(b.date))
            })

            console.log(dateSeries)

            if (dateSeries.length >= 4) {
                if (validateDateSeries(dateSeries)) {
                    // заполняем временое расписание 2/2
                    const firstDate = moment(dateSeries[0].date)
                    const adminFirst = dateSeries[0].admin
                    const adminTwo = dateSeries[2].admin
                    const numberFirst = dateSeries[0].number
                    const numberTwo = dateSeries[2].number

                    for (let i = 0; i < 60; i++) {
                        // Увеличиваем дату на 1 день
                        let newDate = firstDate.format('YYYY-MM-DD');

                        // Определяем admin: чередуем каждые два элемента
                        let admin = (i % 4 < 2) ? adminFirst : adminTwo;
                        let number = (i % 4 < 2) ? numberFirst : numberTwo;

                        firstDate.add(1, 'days')
                    }

                } else {
                    $('#type2').prop('checked', true);
                    type = 'custom'
                }
            }

        }
        renderCalendar()
    }

    const validateDateSeries = (dateSeries) => {
        if (dateSeries.length < 1) {
            return false;
        }

        // Группируем администраторов по датам
        const adminsByDate = {};
        dateSeries.forEach(item => {
            if (!adminsByDate[item.date]) {
                adminsByDate[item.date] = [];
            }
            adminsByDate[item.date].push(item.admin);
        });

        // Сортируем даты
        const dates = Object.keys(adminsByDate).sort((a, b) => moment(a).diff(moment(b)));

        // Проверка последовательности дат без пропусков
        for (let i = 1; i < dates.length; i++) {
            if (moment(dates[i]).diff(moment(dates[i - 1]), 'days') !== 1) {
                return false;
            }
        }

        // Успешная проверка для 4 или более дней
        if (dates.length >= 4) {
            for (let i = 0; i < dates.length; i++) {
                const currentAdmins = adminsByDate[dates[i]].sort();
                // Проверяем дни, отстоящие на 4 дня
                for (let j = i + 4; j < dates.length; j += 4) {
                    const nextAdmins = adminsByDate[dates[j]].sort();
                    if (JSON.stringify(currentAdmins) !== JSON.stringify(nextAdmins)) {
                        return false;
                    }
                }
            }
            return true;
        }

        return false;
    }


    const handlerTooltip = function() {
        $('.calendar-container').on('mouseenter', 'td.active', function(event){
            const element = $(this)
            let text = ''
            // Показать подсказку при наведении

            for (let adminCalendarKey in adminCalendar) {
                adminCalendar[adminCalendarKey].filter(function(item) {
                    return item.date === element.attr('data-date')
                }).map(function(item) {
                    text += admins[adminCalendarKey] + '<br>'
                        + item.number + '<br>'
                })
            }

            $('#tooltip').html(text)
                .css({
                    'top': event.pageY + 10 + 'px',
                    'left': event.pageX + 10 + 'px',
                    'opacity': 1
                })
                .fadeIn(0);
        })
        $('.calendar-container').on('mouseleave', 'td.active', function(){
            // Скрыть подсказку при уходе курсора
            $('#tooltip').fadeOut(0);
        });

        // Следить за перемещением мыши
        $('.calendar-container td.active').on('mousemove', function(event){
            $('#tooltip').css({
                'top': event.pageY + 10 + 'px',
                'left': event.pageX + 10 + 'px'
            });
        });
    }

    const handlerCheck = function() {
        const td = $(this)
        const currentAdmin = $('#admin').val()
        const currentNumber = $('#number').val()

        if (currentAdmin) {
            // при нажатии добавить или убрать из массива adminCalendar
            if (adminCalendar[currentAdmin].filter(function(item) {
                return item.date === td.attr('data-date')
            }).length > 0) {
                adminCalendar[currentAdmin] = adminCalendar[currentAdmin].filter(function(item) {
                    return item.date !== td.attr('data-date')
                })
            } else {
                adminCalendar[currentAdmin].push({
                    date: td.attr('data-date'),
                    number: currentNumber
                })
            }
            handlerType()
            renderCalendar()
        } else {
            alert('Не выбран администратор')
        }

    }

    const handlerSave = () => {

        console.log(adminCalendar);

        $.ajax({
            type: 'POST',
            url: '/ii-call/schedule-calendar',
            data: JSON.stringify({
                scheduleType: type,
                scheduleNotification: notification,
                scheduleResponsible: responsible,
                adminCalendar
            }),
            contentType: 'application/json',
            success: function(result) {
                console.log(result)
                alert('Расписание сохранено')
            }
        })
    }

    const renderCalendar = () => {

        $('#calendar tbody').html('')

        const date = currentDate.clone()

        // Генерируем 4 недели
        for (let week = 0; week < 4; week++) {
            const row = document.createElement('tr');

            // Генерируем 7 дней для каждой недели
            for (let day = 0; day < 7; day++) {

                let active = false
                let temp = false
                let background = false
                let backgroundList = []

                for (let adminCalendarKey in adminCalendar) {
                    if (adminCalendar[adminCalendarKey].filter(function(item) {
                        return item.date === date.format('YYYY-MM-DD')
                    }).length > 0) {
                        active = true
                        background = true
                        backgroundList.push(adminColor[adminCalendarKey])
                    }
                    //временый для 2/2
                    if (type === 'double' && dateSeries.length >= 4 && adminCalendar[adminCalendarKey].filter(function(item) {
                        return moment(item.date).diff(moment(date.format('YYYY-MM-DD')), 'days') % 4 === 0
                    }).length > 0) {
                        temp = true
                        background = true
                        backgroundList.push(adminColor[adminCalendarKey])
                    }
                }

                const cell = document.createElement('td');
                cell.setAttribute('data-date', date.format('YYYY-MM-DD'));
                cell.classList.add('day');
                if (active) {
                    cell.classList.add('active');
                }
                if (temp) {
                    cell.classList.add('temp');
                }

                // Создаем div для заголовка
                const titleDiv = document.createElement('div');
                titleDiv.classList.add('title');

                const daySpan = document.createElement('span');
                daySpan.textContent = date.format('D');

                const monthSpan = document.createElement('span');
                monthSpan.textContent = date.format('MMM');

                titleDiv.appendChild(daySpan);
                titleDiv.appendChild(document.createElement('br'));
                titleDiv.appendChild(monthSpan);

                // Добавляем titleDiv и background div в ячейку
                cell.appendChild(titleDiv);
                const backgroundDiv = document.createElement('div');
                backgroundDiv.classList.add('background');
                if (background) {
                    backgroundList.forEach(function(element) {
                        const backgroundElementDiv = document.createElement('div');
                        backgroundElementDiv.classList.add('element');
                        backgroundElementDiv.style = `background-color: ${element}`
                        backgroundDiv.appendChild(backgroundElementDiv)
                    })
                }
                cell.appendChild(backgroundDiv)

                row.appendChild(cell);

                // Переходим к следующему дню
                date.add(1, 'd');
            }

            // Добавляем строку в тело таблицы
            $('#calendar tbody').append(row);
        }

        // $('.calendar-container td').each(function(index, element) {
        //     $(element)
        //         .removeClass('active')
        //         .find('.background').html('')
        //
        //     for (let adminCalendarKey in adminCalendar) {
        //         if (adminCalendar[adminCalendarKey].filter(function(item) {
        //             return item.date === $(element).attr('data-date')
        //         }).length > 0) {
        //
        //             $(element)
        //                 .addClass('active')
        //                 .find('.background').append('<div class="element" style="background-color: '+ adminColor[adminCalendarKey] +'"></div>')
        //         }
        //         //временый для 2/2
        //         if (adminTempCalendar[adminCalendarKey]?.filter(function(item) {
        //             return item.date === $(element).attr('data-date')
        //         }).length > 0) {
        //
        //             $(element)
        //                 .addClass('temp')
        //                 .find('.background').append('<div class="element" style="background-color: '+ adminColor[adminCalendarKey] +'"></div>')
        //         }
        //     }
        // })
    }

    init()
}
